import BaseModelAPI from '../BaseModelAPI';

export default class PartClassification extends BaseModelAPI {
	static entity = 'partclassification';
	static entityName = 'partclassification';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.code = '';
			this.name = '';
			this.isNeedNextProcess = false;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}